import { useMemo, useState } from "react";
import { buildSimplifiedChartModel } from "./simplifiedChart";

const EMPTY_FILTERS = {
  startDate: "",
  endDate: "",
  platforms: [],
};

export const useSimplifiedChart = ({
  accounts,
  bankroll,
  chartColors,
  displayCurrency,
  hasAccountValues,
}) => {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const model = useMemo(
    () =>
      buildSimplifiedChartModel({
        accounts,
        bankroll,
        chartColors,
        displayCurrency,
        filters,
        hasAccountValues,
      }),
    [accounts, bankroll, chartColors, displayCurrency, filters, hasAccountValues]
  );
  const chartFilters = {
    ...filters,
    platforms: model.selectedPlatforms,
  };
  const hasActiveFilters = Boolean(
    chartFilters.startDate ||
      chartFilters.endDate ||
      chartFilters.platforms.length
  );

  const setChartFilter = (name, value) => {
    setFilters((current) => ({
      ...current,
      [name]: value,
    }));
  };

  return {
    ...model,
    chartFilters,
    clearChartFilters: () => setFilters(EMPTY_FILTERS),
    hasActiveFilters,
    setChartFilter,
  };
};
